import type { ProjectTime } from "./Timing";

export const MinOverrideFilter = ({
	time,
	setTime,
}: {
	time: ProjectTime;
	setTime: (v: boolean) => void;
}) => {
	return (
		<div className="checkbox-wrapper">
			<label htmlFor={"switch"}>Override Min:</label>
			<input
				id={"switch"}
				type={"checkbox"}
				className={"checkbox"}
				checked={time.override_minimum}
				onChange={(v) => setTime(v.target.checked)}
			/>
			{/** biome-ignore lint/a11y/noLabelWithoutControl: This extra label is required for the Toggle class */}
			<label htmlFor="switch" className="toggle" />
		</div>
	);
};
